"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUESTION_TYPES_WITH_CHOICES = void 0;
const question_1 = require("../enums/question");
exports.QUESTION_TYPES_WITH_CHOICES = [question_1.QuestionType.Multiple, question_1.QuestionType.MultipleCheckboxes];
